<template>
  <div>
    <my-asidebar v-bind:active-tab="'seaTour'"> </my-asidebar>

    <section class="dashboard-area">
      <top-bar></top-bar>
      <div class="dashboard-content-wrap">
        <div class="dashboard-bread dashboard--bread dashboard-bread-2">
          <div class="container-fluid">
            <div class="row align-items-center">
              <div class="col-lg-6">
                <div class="breadcrumb-content">
                  <div class="section-heading">
                    <h2 class="sec__title font-size-30 text-white">Tur</h2>
                  </div>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="breadcrumb-list text-right">
                  <ul class="list-items">
                    <li><a :href="basePath" class="text-white">Anasayfa</a></li>
                    <li>Tur</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <sea-tour-list></sea-tour-list>
      </div>
    </section>

  </div>
</template>

<script>
import SeaTourList from "../component/seatour/SeaTourList";
import TopBar from "../component/common/TopBar";
import MyAsidebar from "../component/common/MyAsidebar";

export default {
  name: "SeaTourListPage",
  components: {MyAsidebar, SeaTourList,  TopBar},
  computed:{
    basePath:{
      get(){
        return this.$store.getters.getBasePath
      }
    },
    panelRights: {
      get() {
        return this.$store.getters.getPanelRightsMap;
      }
    }
  },
  mounted() {
    if(!this.panelRights["PANEL_PAGE_SEATOUR_LIST"]) this.$router.push("/");

  }
}
</script>

<style scoped>

</style>